export default {
  name: "HeaderTabs",
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};